<template>
  <div class="dealer-wait-status-legend">
    <span v-for="entry in entries" :key="entry.label">
      <span class="tag-level-desing dealer-wait-status-tag" :class="entry.tone">{{ entry.label }}</span>
      {{ entry.meaning }}
    </span>
  </div>
</template>
<script>
import { WAIT_TOLERANCE_MINUTES, ON_TIME_LABEL, DELAYED_LABEL, NOT_COUNTED_LABEL } from "@/utils/dealerWaitThresholds";
import { ON_TIME_TONE, DELAYED_TONE, NOT_COUNTED_TONE } from "@/utils/dealerWaitRouteStatus";

const LEGEND_ENTRIES = [
  { label: ON_TIME_LABEL, tone: ON_TIME_TONE, meaning: `salió dentro de los ${WAIT_TOLERANCE_MINUTES} min` },
  { label: DELAYED_LABEL, tone: DELAYED_TONE, meaning: `pasó los ${WAIT_TOLERANCE_MINUTES} min y cuenta para el nivel` },
  { label: NOT_COUNTED_LABEL, tone: NOT_COUNTED_TONE, meaning: "la espera no es de la cocina" }
];

export default {
  name: "DealerWaitStatusLegend",
  data: () => ({
    entries: LEGEND_ENTRIES
  })
};
</script>
<style lang="scss">
.dealer-wait-status-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 22px;
  margin-top: 18px;
  font-size: 14px;
  color: #666;
}
</style>
